import {
  Code,
  ConnectError,
  Interceptor,
  StreamResponse,
} from '@bufbuild/connect';

import { debug } from '@/shared/lib';

const TRACE_ID_HEADER = 'X-Dc-Trace-Id';

const logTraceError = (
  reason: unknown,
  url: string,
  responseHeader?: Headers,
): void => {
  const error = ConnectError.from(reason);

  if (error.code === Code.Canceled) {
    return;
  }

  const traceId =
    error.metadata.get(TRACE_ID_HEADER) ??
    responseHeader?.get(TRACE_ID_HEADER) ??
    '-';

  const httpStatus = /^HTTP (\d{3})$/.exec(error.rawMessage)?.[1];
  const status = httpStatus ?? Code[error.code];

  debug(`${TRACE_ID_HEADER} [${traceId}] POST ${url} ${status}`);
};

const wrapStreamResponse = (
  response: StreamResponse,
  url: string,
): StreamResponse => ({
  ...response,
  message: (async function* () {
    try {
      yield* response.message;
    } catch (error) {
      logTraceError(error, url, response.header);
      throw error;
    }
  })(),
});

export const traceIdInterceptor: Interceptor = (next) => async (request) => {
  try {
    const response = await next(request);

    if (response.stream) {
      return wrapStreamResponse(response, request.url);
    }

    return response;
  } catch (error) {
    logTraceError(error, request.url);
    throw error;
  }
};
